import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMFreightTermAsync,
  deleteOMFreightTermAsync,
  editOMFreightTermAsync,
  getOMFreightTermAsync,
} from "../../../store/services/orderManagementService";
const FreightTerm = () => {
  const dispatch = useDispatch();
  const {
    getOMFreightTermStatus,
    getOMFreightTermError,
    getOMFreightTermData,
    addOMFreightTermStatus,
    addOMFreightTermData,
    addOMFreightTermError,

    editOMFreightTermStatus,
    editOMFreightTermError,
    editOMFreightTermData,

    deleteOMFreightTermData,
    deleteOMFreightTermStatus,
    deleteOMFreightTermError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMFreightTermAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMFreightTermData?.length
    ? getOMFreightTermData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedFreightTerm, setSelectedFreightTerm] = useState();
  const [addFreightTermMode, setAddFreightTermMode] = useState(false);
  const [addFreightTermData, setAddFreightTermData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedFreightTerm", selectedFreightTerm);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMFreightTermStatus === asyncStatus.SUCCEEDED) {
      setAddFreightTermMode(false);
      setSaveDisabled(true);
      setAddFreightTermData();
    }
  }, [, addOMFreightTermStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMFreightTermAsync(selectedFreightTerm?.freight_term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMFreightTermStatus === asyncStatus.SUCCEEDED || deleteOMFreightTermStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedFreightTerm();
    }
  }, [, deleteOMFreightTermStatus]);
  useEffect(() => {
    if (editOMFreightTermStatus === asyncStatus.SUCCEEDED) {
      setSelectedFreightTerm();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMFreightTermStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this freight term?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Freight Term"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Freight Term
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddFreightTermMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addFreightTermMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFreightTermMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddFreightTermMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFreightTermMode || !selectedFreightTerm}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMFreightTermStatus === asyncStatus.LOADING ||
                  editOMFreightTermStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addFreightTermData) {
                    dispatch(addOMFreightTermAsync(addFreightTermData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedFreightTerm, ...editData };
                    delete a.id;
                    dispatch(editOMFreightTermAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "freight_term_id", headerName: "ID", flex: true },
                  { field: "freight_term_name", headerName: "Freight Term", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedFreightTerm(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMFreightTermStatus === asyncStatus.IDLE ||
                  getOMFreightTermStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addFreightTermMode ? (
              <InputWithBtnLayoutComp
              error={addOMFreightTermError}
                inputArray={[
                  {
                    label: "Freight Term:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddFreightTermData({
                            ...addFreightTermData,
                            freight_term_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddFreightTermData({
                            ...addFreightTermData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedFreightTerm ? (
              <InputWithBtnLayoutComp
              error={editOMFreightTermError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedFreightTerm?.freight_term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Freight Term:",
                    comp: (
                      <InputComp
                        key={selectedFreightTerm?.freight_term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            freight_term_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedFreightTerm?.freight_term_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedFreightTerm?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedFreightTerm?.is_active || editData?.is_active}
                        defaultChecked={selectedFreightTerm?.is_active || editData?.is_active}
                        // checked={selectedFreightTerm?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any freight term</Typography>
              <Typography color={"red"} fontSize={12}>{getOMFreightTermError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedFreightTerm(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedFreightTerm(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default FreightTerm;
